const TailoringHeader = () => {
  return (
    <section className="bg-gradient-to-br from-primary to-white py-16">
      <div className="container mx-auto px-6 text-center">
        <h1 className="text-6xl font-bold text-accent mb-4">اطلب تفصيلك الآن</h1>
        <p className="text-xl text-gray-700">املأ البيانات وسنتواصل معك خلال 24 ساعة</p>
      </div>
    </section>
  );
};

export default TailoringHeader;